import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import 'jquery/dist/jquery.min.js';
import Fullcalendar from '@fullcalendar/react';
import DayGridPlugin from '@fullcalendar/daygrid';
import InteractionPlugin from '@fullcalendar/interaction';
import Addbooking from './Booking/addbooking';
import axios from 'axios'
import * as $ from 'jquery';
import Moment from 'moment';
import 'bootstrap'
import Royal_logo from '../Assets/images/Royal-logo.svg'
import html2pdf from 'html2pdf.js';
import Notice from '../Assets/images/Roya-Resort-Notice.png'
import Select from 'react-select';


export default function Home(props) {

    const [events, setevents] = useState([])
    const [eventdate, seteventdate] = useState(new Date());
    const [bookingdetails, setbookingdetails] = useState({});
    const [receviedamount, setreceviedamount] = useState({});
    const [isCheckedmon, setIsCheckedmon] = useState(false);
    const [isCheckedtue, setIsCheckedtue] = useState(false);
    const [isCheckedwed, setIsCheckedwes] = useState(false);
    const [isCheckedsch, setIsCheckedsch] = useState(false);
    const [isCheckedfri, setIsCheckedfri] = useState(false);
    const [units, setUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState(null);
    const [loading, setLoading] = useState(false);
    const formOptions = [
        { label: "Corporate", value: "1" },
        { label: "Family", value: "2" },
        { label: "Edu. Institute", value: "3" },
        { label: "Friend", value: "5" }
    ];
    const handledateclick = (arg) => {
        const selectedDate = new Date(arg.dateStr);
        const currentDate = new Date();

        // Check if the selected date is valid (current or future date)
        if (selectedDate >= currentDate.setHours(0, 0, 0, 0)) {
            seteventdate(arg.dateStr);
            if (props.usertypeid == 1 || props.usertypeid == 2 || props.usertypeid == 3 || props.usertypeid == 5) {
                $("#myModal").modal('show');
            }
        } else {
            swal({
                title: "Invalid Date",
                text: "You can only select the current date or future dates.",
                icon: "error",
            });
        }
    };
    const [typevalue, settypevalue] = useState()
    const [sto, setsto] = useState()
    const [sfro, setsfro] = useState()
    const [type, settype] = useState([
        { label: "Corporate", value: "1" },
        { label: "Family", value: "2" },
        { label: "Edu. Institute", value: "3" },
        { label: "Friend", value: "5" }
    ])
    useEffect(() => {
        fetchUnitData();
        fetcheveintdata()
    }, [])

    // fetch all units

    async function fetchUnitData() {
        try {
            const UnitUrl = `${process.env.REACT_APP_APIURL}FramUnit/GetFramUnits?companyid=${props.companyid}`;
            const response = await axios.get(UnitUrl);
            const unitOptions = response.data.map((unit) => ({
                value: unit.unitId,
                label: unit.unitName, // Form names like Clan, Grande, Supreme
            }));
            setUnits(unitOptions);
        } catch (error) {
            console.error("Error fetching unit data:", error);
        }
    }


    async function fetcheveintdata(selectedUnit = null) {
        setLoading(true); // Set loading state
        try {
            const baseUrl = `${process.env.REACT_APP_APIURL}booking/GetEventList?companyid=${props.companyid}`;
            // console.log(baseUrl);
            const eventUrl = selectedUnit
                ? `${process.env.REACT_APP_APIURL}booking/GetEventListbyunit?companyid=${props.companyid}&unitid=${selectedUnit}`
                : baseUrl;
            // console.log(`${process.env.REACT_APP_APIURL}booking/GetEventListbyunit?companyid=${props.companyid}&unitid=${selectedUnit}`)
            const response = await axios.get(eventUrl);
            const modifiedEvents = response.data.map(event => ({
                ...event,
                title: event.title.replace(/  -  /g, '\n\r').replace(/ - /g, '\n\r').trim(),
                extendedProps: {
                    ...event.extendedProps,
                    type: event.type,
                }
            }));

            setevents(modifiedEvents); // Set the events (all or filtered)
        } catch (error) {
            console.error("Error fetching event data:", error);
        } finally {
            setLoading(false); // Reset loading state
        }
    }

    const handleUnitChange = (selected) => {
        setSelectedUnit(selected);
        fetcheveintdata(selected ? selected.value : null); // Fetch filtered or all events
    };

    const savingStatus = async (e) => {

        if (e) {
            await fetcheveintdata()
            $("#myModal").modal('hide');
        }
    }
    const HandlEventClick = (arg) => {
        const url = process.env.REACT_APP_APIURL + "Booking/GetALLBooking?bookingId=" + arg.event.id + "&companyid=" + props.companyid;
        fetch(url).then(res => res.json()).then(result => {

            // console.log(result);

            if (result.shiftId == 1037) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 PM " + newDate);
            }
            if (result.shiftId == 1038) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 AM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1039) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 AM " + newDate1);
            }
            if (result.shiftId == 1040) {
                const newDate = Moment(new Date(result.bookingdate)).format('dddd');
                const newDate1 = Moment(new Date(result.bookingdate)).add(1, 'day').format('dddd');
                setsto("8:00 PM " + newDate);
                setsfro("6:00 PM " + newDate1);
            }
            if (result.type == "1") {
                setIsCheckedmon(true);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);

                settypevalue("Corporate")
            }
            if (result.type == "2") {
                setIsCheckedmon(false);
                setIsCheckedtue(true);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                settypevalue("Family")
            }
            if (result.type == "3") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(true);
                setIsCheckedsch(false);
                setIsCheckedfri(false);
                settypevalue("Edu. Institute")
            }
            if (result.type == "4") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(true);
                setIsCheckedfri(false);
                settypevalue("School")
            }
            if (result.type == "5") {
                setIsCheckedmon(false);
                setIsCheckedtue(false);
                setIsCheckedwes(false);
                setIsCheckedsch(false);
                setIsCheckedfri(true);
                settypevalue("Friend")
            }
            if (result.status == 404) {
                swal(
                    {
                        icon: 'error',
                        title: 'Not found!',
                    })
            }
            else {
                $("#myModal1").modal('show');
                setbookingdetails(result)
                paymentdata(arg.event.id)
                //console.log(result)
            }

        }).catch((err) => {
            console.log(err);
        });
    }

    async function paymentdata(id) {
        const url = process.env.REACT_APP_APIURL + "payment/GetReceviedAmount?bookingid=" + id + "&companyid=" + props.companyid;
        await fetch(url).then(res => res.json()).then(result => {

            if (result.status == 404) {
                receviedamount.payment = 0
            }
            else {
                setreceviedamount(result);
            }

        }).catch((err) => {
            console.log(err);
        });
    }
    const modelOut1 = (e) => {
        e.preventDefault();
        $("#myModal1").modal('hide');
    }
    const dwn = (e) => {
        e.preventDefault();
        let printEleme = document.getElementById('elementPrint');
        var opt = {
            filename: `Advance-Receipt_${bookingdetails.bookingId}`,
        };
        setTimeout(() => {
            html2pdf().set(opt).from(printEleme).save();
        }, 300);
    }

    /* inline styling */
    const card = {
        marginBottom: '1.875rem',
        backgroundColor: '#fff',
        transition: 'all 0.5s ease-in-out',
        position: 'relative',
        border: '0rem solid transparent',
        borderRadius: '1.375rem',
        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
        height: 'calc(100% - 1.875rem)',
    }
    const card_body = {
        padding: '0.5rem 2rem 0rem',
        flex: '1 1 auto',
    }
    const card_header = {
        borderColor: '#ffffff',
        position: 'relative',
        background: '#1d3641',
        padding: '1.5rem 1.875rem 1.25rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#002a73',
        borderRadius: '0 !important',
        backgroundColor: '#fff',
        paddingBottom: '0',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '1.2rem',
    }
    const card_logo = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const img_logo = {
        width: '225px',
        height: '75px',

    }
    const re_heading = {
        marginTop: '0.5rem',
    }
    const d_grid = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    }
    const lineGrid = {
        disply: 'flex',
        marginBottom: '0.5rem',
    }
    const inLIne = {
        disply: 'flex',
        paddingRight: '0.6rem',
    }
    const pdRight = {
        paddingRight: '0.5rem',
    }
    const uLine = {
        fontWeight: '600',
        borderBottom: '1px solid gray',
        transform: 'translateY(-6px)',
        paddingLeft: '0.3rem',
        fontSize: '0.9rem',
    }
    const p_right = {
        paddingRight: '0.8rem',
    }
    const f_child = {
        paddingRight: '0.2rem',
        fontSize: '0.9rem',
    }
    const in_checkBox = {
        display: 'inline-flex',
        alignItems: 'center',
    }
    const in_label = {
        paddingRight: '0.2rem',
        margin: '0',
    }
    const in_checkbox = {
        height: '15px',
        width: '15px',
    }
    const center_text = {
        textAlign: 'center',
    }
    const fn_size = {
        fontSize: '0.8rem',
        marginBottom: '0',
    }
    const flx_main = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
    }
    const col_5 = {
        display: 'flex',
        flex: "0 0 50%",
        maxWidth: "50%",
    }
    const col_4 = {
        flex: '0 0 40%',
        maxWidth: '40%',
    }
    const col_6 = {
        flex: '0 0 60%',
        maxWidth: '60%',
    }
    const col_7 = {
        flex: '0 0 70%',
        maxWidth: '70%',
    }
    const col_8 = {
        flex: '0 0 80%'
    }
    const col_3 = {
        flex: '0 0 30%',
        maxWidth: '30%',
    }
    const col_2 = {
        flex: '0 0 20%',
        maxWidth: '20%',
    }
    const col_1 = {
        flex: '0 0 10%',
        maxWidth: '10%',
    }
    const col_9 = {
        flex: '0 0 90%',
        maxWidth: '90%',
    }
    const col_10 = {
        flex: "0 0 100%",
        maxWidth: '100%',
    }
    const col_65 = {
        flex: '0 0 65%',
        maxWidth: '65%',
    }
    const col_25 = {
        flex: '0 0 25%',
        maxWidth: '25%',
    }
    const m_b1 = {
        marginBottom: '1rem',
    }
    const d_flex = {
        display: 'flex',
    }
    const under_line = {
        textDecoration: 'underline',
    }
    const ul_list = {
        marginBottom: '0.4rem',
        listStyle: 'auto',
    }
    const ul_sty = {
        paddingLeft: '1.5rem'
    }
    const mr_top3 = {
        marginTop: '3rem',
    }
    /* change today text button */
    useEffect(() => {
        const updateButtonText = () => {
            const button = document.querySelector('.fc-today-button');
            if (button) {
                button.textContent = 'This Month';
            }
        };

        updateButtonText(); // Call the function immediately when the component mounts

        // Cleanup function
        return () => {
            // Reset the button text when the component unmounts
            const button = document.querySelector('.fc-today-button');
            if (button) {
                button.textContent = '';
            }
        };
    }, []);

    const renderEventContent = (eventInfo) => {
        const regex = /S\d+/;
        const title = eventInfo.event.title;
        const serialMatch = title.match(regex);
        const { remaining } = eventInfo.event.extendedProps; // Access remaining value from extendedProps
        const screenWidth = window.innerWidth;

        // If the screen width is 575px or smaller, show only the serial number
        if (screenWidth <= 575) {
            return (
                <div className="fc-event-title fc-sticky">
                    {serialMatch ? (
                        <>
                            <span>{serialMatch[0]}</span>
                        </>
                    ) : (
                        <span>{title}</span>
                    )}
                </div>
            );
        }

        // Otherwise, show the full title for larger screens
        return (
            <div className="fc-event-title fc-sticky">
                <span>
                    {title}
                    {remaining > 0 && <span className="remaining">Remaining: {remaining.toLocaleString()}</span>}
                </span>
            </div>
        );
    };
    const updatedEvents = events.map(event => {
        if (event.title && event.title.includes('S')) {
            return {
                ...event,
                extendedProps: {
                    ...event.extendedProps,
                    remaining: event.remaining,
                }
            };
        }
        return event;
    });

    return (
        <>

            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header d-flex">
                            <h3 className="me-auto mb-0">Calendar</h3>
                            <div className="shift-colors">
                                <ul>
                                    <li><span className='today_booking'></span>Today</li>
                                    <li><span className='m_booking'></span>Morning</li>
                                    <li><span className='e_booking'></span>Evening</li>
                                    <li><span className='f_booking'></span>Full Day</li>
                                </ul>
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="mb-3 col-sm-3">
                                <label className="form-label">Select Type</label>
                                <Select
                                    name="unit"
                                    value={selectedUnit}
                                    options={units}
                                    onChange={handleUnitChange}
                                    isClearable
                                    required
                                />
                            </div>
                            {loading ? (
                                <section className='loader_main'>
                                    <span className="loader-5"></span>
                                </section>
                            ) : (
                                <Fullcalendar
                                    selectable={false}
                                    plugins={[DayGridPlugin, InteractionPlugin]}
                                    dateClick={handledateclick}
                                    headerToolbar={{
                                        left: 'prev,next,today',
                                        center: 'title',
                                        right: 'timeGridWeek,timeGridDay',
                                    }}
                                    dayMaxEventRows={3}
                                    events={updatedEvents}
                                    eventClick={HandlEventClick}
                                    eventContent={renderEventContent}
                                />
                            )}

                            {/* modal start */}
                            <div id="myModal" className="modal fade inner_modal-width" tabIndex="-1">
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <Addbooking savingStatus={savingStatus} date={eventdate} companyid={props.companyid} />
                                    </div>
                                </div>
                            </div>
                            <div id="myModal1" className="modal fade " tabIndex="-1">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content" >
                                        {/* card start */}
                                        <div className='card' id="elementPrint">
                                            <div className='card-header d-flex flex-column' >
                                                <div style={card_logo}>
                                                    <img style={img_logo} src={Royal_logo} alt="Royal-Logo" />
                                                </div>
                                                <h3 style={re_heading}>Advance Receipt</h3>
                                                <div className='download_button' id='repoPrint' data-html2canvas-ignore="true"><a onClick={dwn} href="">Download</a><a onClick={modelOut1} href="">✕</a></div>
                                            </div>
                                            <div className='card-body'>
                                                <div className='main_layer_column' style={d_grid}>
                                                    <div style={lineGrid}>
                                                        <span style={inLIne}><span style={f_child}>Srl#</span><span style={uLine}>{"S" + bookingdetails.bookingId}</span></span>
                                                    </div>
                                                    <div style={lineGrid} className='input-grup'>
                                                        <span style={inLIne}><span style={f_child}>Booking Date:</span><span style={uLine}>{Moment(bookingdetails.bookingdate).format('DD/MM/yyyy')}</span></span>
                                                        <span style={inLIne}><span style={f_child}>Farm#</span><span style={uLine}>{bookingdetails.unitName}</span></span>
                                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="company">Company</label><input style={in_checkbox} type="checkbox" id='company' checked={isCheckedmon} readOnly /></span></span>
                                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="family">Family</label><input style={in_checkbox} type="checkbox" id='family' checked={isCheckedtue} readOnly /></span></span>
                                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Edu. Institute">Edu. Institute</label><input style={in_checkbox} type="checkbox" id='Edu. Institute' checked={isCheckedwed} readOnly /></span></span>
                                                        <span style={inLIne}><span style={in_checkBox}><label style={in_label} htmlFor="Friend">Friend</label><input style={in_checkbox} type="checkbox" id='Friend' checked={isCheckedfri} readOnly /></span></span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...center_text, ...flx_main }}>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm3 tm-md-1' style={{ ...f_child, ...col_5 }}>TImeSlot:(Day & Time)</span><span style={{ ...uLine, ...col_5 }}>{sto}</span></span>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2-3 tm-md-2' style={{ ...f_child, ...col_4 }}>To(Day & Time)</span><span style={{ ...uLine, ...col_6 }}>{sfro}</span></span>
                                                        <span style={col_10}><strong><p style={fn_size}>(22H Booking: Morning 8am to 6am or Night 8pm to 6pm next day & for 10H: Morning 8am to 6pm or Night 8pm to 6am)</p></strong> </span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...flx_main }}>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm4-3 gm-md-1' style={{ ...f_child, ...col_65 }}>No. of "Guests Allowed" (Max.)</span><span style={{ ...uLine, ...col_2 }}>{bookingdetails.noOfMembers}</span></span>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm1-8 ev-md-2' style={{ ...f_child, ...col_3 }}>Event Type:</span><span style={{ ...uLine, ...col_7 }}>{typevalue}</span></span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...flx_main }}>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2 cl-md-1' style={{ ...f_child, ...col_3 }}>Client Name:</span><span style={{ ...uLine, ...col_7 }}>{bookingdetails.cusName}</span></span>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span style={{ ...f_child, ...col_1 }}>Cell</span><span style={{ ...uLine, ...col_9 }}>{bookingdetails.phone ? bookingdetails.phone.replace(/(\d{4})(\d{7})/, '$1 $2') : 'N/A'}</span></span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...flx_main }}>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm2-5 tlt-md-1' style={{ ...f_child, ...col_4 }}>Total Amount:Rs. </span><span style={{ ...uLine, ...col_4 }}>{bookingdetails.amount}</span></span>
                                                        <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5 }}><span className='colsm4-3 paid-md-2' style={{ ...f_child, ...col_6 }}>Amount Paid (Advance): Rs.</span><span style={{ ...uLine, ...col_4 }}>{receviedamount.payment}</span></span>
                                                        <span style={{ ...col_10, ...m_b1 }}><strong><p style={fn_size}></p></strong> </span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...flx_main }}>
                                                        <span className='main-col-item m-b-1 ful-width' style={{ ...inLIne, ...col_6, ...d_flex }}><span className='colsm3 bl-md-1' style={{ ...f_child, ...col_4 }}>Balance Amount: Rs.</span><span className='remaining inside' style={{ ...uLine, ...col_4 }}>{(isNaN(bookingdetails.amount) ? 0 : bookingdetails.amount) - (isNaN(receviedamount.payment) ? 0 : receviedamount.payment)}</span></span>
                                                    </div>
                                                    <div style={{ ...lineGrid, ...flx_main }}>
                                                        <span className='main-col-item m-b-1 ful-width' style={{ ...inLIne, ...col_10, ...d_flex }}><span className='colsm3-5 adi-md-1' style={{ ...f_child, ...col_25 }}>Note: </span><span className='colsm6-5' style={{ ...uLine, ...col_7 }}>{bookingdetails.note}</span></span>
                                                    </div>
                                                    <p className='mb-3 contact-farm'><strong>Farm Contact No. 0301-0881116</strong></p>
                                                </div>
                                                {/* important notes */}
                                                <div>
                                                    <h5>IMPORTANT NOTES:</h5>
                                                    <ul className='list-Style' style={ul_sty}>
                                                        <li style={ul_list}>Read carefully the attached "Booking Contract & Rules Regulations".</li>
                                                        <li style={ul_list}>Full payment is required to be paid at least before 48 hours(2 days) of the program/party for issuance of "Gate Pass". <span className='underline' >No one is allowed to enter in Resort / Farmhouse without "Gate Pass". </span></li>
                                                        <li style={ul_list}>Please inform us at least one week prior to the event, in case of any changes or cancellation of event, Your amount can be adjusted to new available date. In case of less than one week you deposited amount will be forfeited.</li>
                                                        <li style={ul_list}> Couples are not allowed without “Nikah Nama” or Proof of Relationship.</li>
                                                        <li style={ul_list}> Use of drinks (alcohol), dance party, any indecent gathering/activity, Loud Music, any kind of weapon, Fireworks, Shisha (Hukkah), Laser Lights, spitting, drone camera, Paan/Gutka, and any illegal activity etc. are strictly not allowed.</li>
                                                        <li style={ul_list}>Maximum "Guest Allowed" would be followed strictly; else you will be required to pay 1000 per person at the farmhouse entery.</li>
                                                        <li style={ul_list}> Resort coupons can be utilized as per scheduled timings that is 5am to 7am or 4pm to 6pm.</li>
                                                        <li style={ul_list}> Sports Activities and other electrical appliances may be suspended due to weather or any other unforeseen reasons at any time.</li>
                                                    </ul>
                                                </div>
                                                {/* footer signnature */}
                                                <div className='html2pdf__page-break'>
                                                    <div style={{ ...d_grid, ...mr_top3 }}>
                                                        <div style={{ ...lineGrid, ...flx_main }}>
                                                            <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_4, ...d_flex }}><span className='bk-md-1' style={{ ...f_child, ...col_4 }}>Booked By:</span><span style={{ ...uLine, ...col_6 }}>{bookingdetails.bookedby}</span></span>
                                                            <span className='main-col-item m-b-1' style={{ ...inLIne, ...col_5, ...d_flex }}><span style={{ ...f_child, ...7 }}>Date of issuing Receipt</span><span style={{ ...uLine, ...col_3 }}>{Moment(bookingdetails.entrydate).format('DD/MM/yyyy')}</span></span>
                                                            <span style={{ ...col_10, ...m_b1 }}><strong><p style={fn_size}></p></strong> </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='my_updatepdf'>
                                                    <img src={Notice} alt="notice_PDf" />
                                                </div>
                                            </div>
                                        </div>
                                        {/* card end */}
                                    </div>
                                </div>
                            </div>
                            {/* modal end */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
